import { useEffect, useState } from 'react';

/** Whether the browser is online; connections cannot change while it is not. */
export function useOnline() {
  const [online, setOnline] = useState(
    typeof navigator === 'undefined' || navigator.onLine
  );
  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);
  return online;
}
